module.exports = __webpack_public_path__ + "img/home_slide7.844f20d5.jpg";